import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Inputbox from "../../Components/Inputbox";
import {
  AddAppoientmentVisit,
  DeleteAppointmentVisit,
  EditReasonVisit,
  FetchAddAppoientmentVisit,
} from "../../../api/helper";
import { ShowToast } from "../../../helpers/ToastService";
import DeleteModal from "../Components/DeleteModal";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Must be at least 3 characters")
    .max(50, "Must not exceed 50 characters"),
  color: Yup.string().required("Color is required"),
  // description: Yup.string().required("Definition is required"),
  isReasons: Yup.boolean(),
  sortOrder: Yup.number()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .min(0, "Sort order cannot be negative"),
  agendatab: Yup.string().required("Agenda is required"),
});

const AppointmentVisitStatus = ({ GetTabStatus }) => {
  const [showModal, setShowModal] = useState(false);
  const [reasonModal, setreasonModal] = useState(false);
  const [reasonText, setReasonText] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [data, setdata] = useState([]);
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editItemId, setEditItemId] = useState(null);

  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const openModal = () => {
    reset();
    setShowModal(true);
  };
  const closeModal = () => {
    reset({
      name: "",
      color: "",
      description: "",
      isReasons: false,
      sortOrder: "",
    });
    setShowModal(false);
    setIsEditMode(false);
    setEditItemId(null);
  };

  const GetAppoientmentVisit = async () => {
    const response = await FetchAddAppoientmentVisit(`?id=${profiledata?._id}`);
    setdata(response?.data?.data);
  };
  useEffect(() => {
    GetAppoientmentVisit();
  }, []);
  const onSubmit = async (formData) => {
    formData.agencyId = profiledata?._id;

    try {
      if (isEditMode) {
        // Edit mode: call update API
        const payload = { ...formData };
        const response = await EditReasonVisit(editItemId, payload);
        ShowToast(response?.data?.message || "Updated successfully");
      } else {
        // Add mode
        const response = await AddAppoientmentVisit(formData);
        ShowToast(response?.data?.message || "Added successfully");
      }

      reset(); // Clear form
      GetAppoientmentVisit(); // Refresh data
      GetTabStatus();
      setShowModal(false);
      setIsEditMode(false); // Reset edit mode
      setEditItemId(null);
    } catch (error) {
      console.log(error);
    }
  };

  //   const EditReason = async () => {
  //   try {
  //     const respo = await EditReasonVisit(itemId,payload);
  //     console.log(respo?.data,"respo======")
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const handleDelete = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };
  const confirmDelete = async () => {
    setconfirmdeletemodal(false);
    try {
      const response = await DeleteAppointmentVisit(`?id=${deleteId}`);
      if (response?.data?.success) {
        ShowToast(response?.data?.message);
        GetAppoientmentVisit();
        GetTabStatus();
      } else {
        ShowToast("Error: Unable to delete address.");
      }
    } catch (error) {
      console.error("Delete operation failed:", error);
      ShowToast("An error occurred while deleting the address.");
    }
  };
  const handleAddReason = async () => {
    const trimmedText = reasonText.trim();
    const ordinal = Number(sortOrder) || 0;

    if (!trimmedText) {
      alert("Please enter a reason text.");
      return;
    }
    const payload = {
      reasionToAdd: [
        {
          reasionText: trimmedText,
          sortOrder: ordinal,
        },
      ],
    };
    const respones = await EditReasonVisit(selectedRow?._id, payload);
    const updatedData = await FetchAddAppoientmentVisit(
      `?id=${profiledata?._id}`
    );
    const updatedRow = updatedData?.data?.data?.find(
      (item) => item._id === selectedRow._id
    );
    if (updatedRow) setSelectedRow(updatedRow);
    await GetAppoientmentVisit();
    setReasonText("");
    setSortOrder("");
  };
  const handleDeleteReason = async (reasonId) => {
    if (!window.confirm("Delete this reason?")) return;
    const payload = {
      reasionToRemove: [reasonId],
    };
    const respones = await EditReasonVisit(selectedRow?._id, payload);
    const updatedData = await FetchAddAppoientmentVisit(
      `?id=${profiledata?._id}`
    );
    const updatedRow = updatedData?.data?.data?.find(
      (item) => item._id === selectedRow._id
    );
    if (updatedRow) setSelectedRow(updatedRow);
    await GetAppoientmentVisit();
  };
  const handleEdit = (row) => {
    setIsEditMode(true);
    setEditItemId(row._id);

    reset({
      name: row.name,
      color: row.color,
      description: row.description,
      isReasons: row.isReasons,
      sortOrder: row.sortOrder,
      agendatab: row.agendatab,
    });

    setShowModal(true);
  };

  return (
    <div className="container_AppointmentVisitStatus">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <h1> Visit Statuses</h1>
        <div className="add-button_user" onClick={openModal}>
          + New Status
        </div>
      </div>

      <table className="table">
        <thead>
          <tr>
            <th>Sort #</th>
            <th>Name &amp; Color</th>
            <th>Has Reasons?</th>
            <th>Definition</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", padding: "10px" }}>
                No Appointment Found
              </td>
            </tr>
          ) : (
            [...data]
              .sort((a, b) => a.sortOrder - b.sortOrder)
              .map((row) => {
                return (
                  <tr key={row._id} style={tableRowStyle}>
                    <td style={tableCellStyle}>{row.sortOrder}</td>
                    <td style={tableCellStyle}>
                      {" "}
                      <div style={{ display: "flex" }}>
                        <div
                          className="Reason_Color"
                          style={{
                            backgroundColor: row.color,
                            borderRadius: 6,
                          }}
                        />
                        {row.name}
                      </div>
                    </td>
                    <td style={tableCellStyle}>
                      {row.isReasons ? "Yes" : "No"}
                    </td>
                    <td style={tableCellStyle}>{row.description}</td>
                    <td style={tableCellStyle}>
                      <button
                        className="action_icon_btn"
                        title="Edit"
                        onClick={() => handleEdit(row)}
                      >
                        <i className="fas fa-edit" style={{ color: "black" }} />
                      </button>
                      <button
                        className="action_icon_btn"
                        title="Delete"
                        onClick={() => handleDelete(row._id)}
                      >
                        <i
                          class="fas fa-trash-alt"
                          style={{ color: "black" }}
                        />
                      </button>
                      {row.isReasons ? (
                        <button
                          className="action_icon_btn"
                          title="Manage Reasons"
                          onClick={() => {
                            setSelectedRow(row);
                            setreasonModal(true);
                          }}
                        >
                          <i class="fas  fa-cogs" style={{ color: "black" }} />
                        </button>
                      ) : null}
                    </td>
                  </tr>
                );
              })
          )}
        </tbody>
      </table>
      <Modal
        open={reasonModal}
        onClose={() => {
          setreasonModal(false);
        }}
        aria-labelledby="modal-title"
      >
        <Box sx={modalStyle}>
          <h2>
            Manage Reasons for “<span>{selectedRow?.name}</span>”
          </h2>
          <div className="reason-list">
            {selectedRow?.reasion?.length > 0 ? (
              selectedRow?.reasion
                .sort((a, b) => a.sortOrder - b.sortOrder)
                .map((reason) => (
                  <div key={reason.id} className="reason-item">
                    <span className="reason-text">
                      <span className="reason-ordinal">
                        {reason.sortOrder}.
                      </span>
                      {reason.reasionText}
                    </span>
                    <button
                      onClick={() => handleDeleteReason(reason?._id)}
                      className="btn_VisitStatus btn_VisitStatus-small btn_VisitStatus-danger"
                    >
                      Delete
                    </button>
                  </div>
                ))
            ) : (
              <p style={{ fontStyle: "italic", color: "#888" }}>
                No reasons added.
              </p>
            )}
          </div>

          <div className="form-group_AppointmentVisitStatus">
            <label htmlFor="newReasonText">Reason Text</label>
            <input
              type="text"
              id="newReasonText"
              value={reasonText}
              onChange={(e) => setReasonText(e.target.value)}
              placeholder="e.g. Client illness, Weather-related"
            />
          </div>
          <div className="form-group_AppointmentVisitStatus">
            <label htmlFor="newReasonOrdinal">Sort Order</label>
            <input
              type="number"
              id="newReasonOrdinal"
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              placeholder={0}
              min={0}
            />
          </div>
          <button
            onClick={handleAddReason}
            className="btn_VisitStatus btn_VisitStatus-primary"
          >
            Add Reason
          </button>
          <div className="form-actions_VisitStatus" style={{ marginTop: 16 }}>
            <button
              onClick={() => setreasonModal(false)}
              className="btn_VisitStatus btn_VisitStatus-secondary"
            >
              Close
            </button>
          </div>
        </Box>
      </Modal>
      <Modal
        open={showModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
      >
        <Box sx={modalStyle}>
          <h2 id="statusModalTitle">Add Visit Status</h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group_AppointmentVisitStatus">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                {...register("name")}
                placeholder="e.g. Canceled, No-Show, Scheduled"
              />
              {errors.name && <p className="error">{errors.name.message}</p>}
            </div>

            <div className="form-group_AppointmentVisitStatus">
              <label>Color</label>
              <input type="color" {...register("color")} />

              <span className="hint_VisitStatus">
                Choose a color that represents this status (e.g. red for
                Canceled).
              </span>
            </div>
            {errors.color && <p className="error">{errors.color.message}</p>}
            <div className="form-group_AppointmentVisitStatus">
              <label>Definition</label>
              <input
                type="text"
                {...register("description")}
                placeholder="Describe what this status means"
              />
              {/* <p style={{ color: "red", textAlign: "left" }}>
                {errors.description?.message}
              </p> */}
            </div>

            <div className="form-group_AppointmentVisitStatus">
              <div style={{ display: "flex", alignItems: "center" }}>
                <input type="checkbox" {...register("isReasons")} />
                <label style={{ marginLeft: 10, marginBottom: 15 }}>
                  Allow “Cancellation Reasons” for this status?
                </label>
              </div>
              <span className="hint_VisitStatus">
                If checked, you can later define reasons (e.g. “Weather,”
                “Illness”).
              </span>
            </div>

            <div className="form-group_AppointmentVisitStatus">
              <label>Sort Order</label>
              <input
                type="number"
                placeholder="0"
                min={0}
                {...register("sortOrder")}
              />
              {errors.sortOrder && (
                <p className="error">{errors.sortOrder.message}</p>
              )}
              <span className="hint_VisitStatus">
                Lower numbers appear first in drop-downs. (Optional)
              </span>
            </div>
            <div className="form-group_CalendarView">
              <label htmlFor="client-select">Agenda Tab</label>
              <select id="client-select" {...register("agendatab")}>
                <option value="">-- Select Agenda --</option>

                <option value={"Scheduled Items"}>Scheduled Items</option>
                <option value={"Finished Items"}>Finished Items</option>
                <option value={"Pending Items"}>Pending Items</option>
              </select>
              {errors.agendatab && (
                <p className="error">{errors.agendatab.message}</p>
              )}
            </div>
            <div className="form-actions_VisitStatus">
              <button
                type="button"
                onClick={closeModal}
                className="btn_VisitStatus btn_VisitStatus-secondary"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn_VisitStatus btn_VisitStatus-primary"
                style={{ marginLeft: 10 }}
              >
                {isEditMode ? "Update" : "Save"}
              </button>
            </div>
          </form>
        </Box>
      </Modal>
      {confirmdeletemodal && (
        <DeleteModal
          name="Visit Status"
          onClose={() => setconfirmdeletemodal(false)}
          onConfirm={confirmDelete}
        />
      )}
    </div>

    // <div
    //   style={{
    //     width: "100%",
    //     alignItems: "center",
    //     justifyItems: "center",
    //     marginBottom: 20,
    //   }}
    // >
    //   <div
    //     style={{
    //       display: "flex",
    //       alignItems: "center",
    //       justifyContent: "space-between",
    //       width: "100%",
    //     }}
    //   >
    //     <h1> Appointment and Visit Status</h1>
    //     <div
    //    className="add-button_user"
    //       onClick={openModal}
    //     >
    //       Add Appointment and Visit Status
    //     </div>
    //   </div>

    //   <div style={{ overflowX: "auto", width: "100%", marginTop: 30 }}>
    //     <div style={{ overflowX: "auto", width: "100%", marginTop: 30 }}>
    //       <table className="table">
    //         <thead>
    //           <tr>
    //             <th>Name</th>
    //             <th>Definition</th>
    //             <th>Action</th>
    //           </tr>
    //         </thead>
    // <tbody>
    //   {data.length === 0 ? (
    //     <tr>
    //       <td
    //         colSpan="3"
    //         style={{ textAlign: "center", padding: "10px" }}
    //       >
    //         No Appointment Found
    //       </td>
    //     </tr>
    //   ) : (
    //     data.map((row) => (
    //       <tr key={row._id} style={tableRowStyle}>
    //         <td style={tableCellStyle}>{row.name}</td>
    //         <td style={tableCellStyle}>{row.description}</td>
    //         <td style={tableCellStyle}>
    //            <button
    //           className="action_icon_btn"
    //           title="Delete"

    //           onClick={() => handleDelete(row._id)}
    //         >
    //           <i class="fas fa-trash-alt" style={{ color: "black" }} />
    //         </button>
    //         </td>
    //       </tr>
    //     ))
    //   )}
    // </tbody>
    //       </table>
    //     </div>
    //   </div>
    // <Modal
    //   open={showModal}
    //   onClose={closeModal}
    //   aria-labelledby="modal-title"
    // >
    //   <Box sx={modalStyle}>
    //     <form
    //       onSubmit={handleSubmit(onSubmit)}
    //       style={{
    //         width: "100%",
    //         alignItems: "center",
    //         justifyItems: "center",
    //         marginBottom: 20,
    //       }}
    //     >
    //       <h1 style={{ textAlign: "left" }}>
    //         Add Appointment and Visit Status
    //       </h1>
    //       <div
    //         style={{
    //           alignItems: "center",
    //           justifyContent: "center",
    //           width: "100%",
    //         }}
    //       >
    //         <Inputbox
    //           label="Name"
    //           className="Custom_input"
    //           type="text"
    //           placeholder="Enter Appointment and Visit Status"
    //           name="name"
    //           register={register}
    //         />
    //         <p style={{ color: "red", textAlign: "left" }}>
    //           {errors.name?.message}
    //         </p>
    //         <Inputbox
    //           label="Definition"
    //           type="text"
    //           placeholder="Enter Appointment and Visit Status Definition"
    //           name="description"
    //           className="Custom_input"
    //           register={register}
    //         />
    //         {/* <p style={{ color: "red", textAlign: "left" }}>
    //             {errors.name?.message}
    //         </p> */}
    //         <button
    //           type="submit"
    //           style={{
    //             marginBottom: 20,
    //             marginTop: 20,
    //             alignSelf: "center",
    //             width: "100%",
    //             height: "50px",
    //           }}
    //           className="Save_buttonnn"
    //         >
    //           Submit
    //         </button>
    //         {/* <p className="text-center">Please make surethe service name is unique</p> */}
    //       </div>
    //     </form>
    //   </Box>
    // </Modal>
    //  {confirmdeletemodal && (
    //   <DeleteModal
    //     name="Appointment and Visit Status"
    //     onClose={() => setconfirmdeletemodal(false)}
    //     onConfirm={confirmDelete}
    //   />
    // )}
    // </div>
  );
};

export default AppointmentVisitStatus;
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  height: "90vh",
  overflowY: "auto", // Set a fixed height for the modal
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 4,
  outline: "none",
  // Enable vertical scrolling
};
const tableHeaderStyle = {
  padding: "10px",
  borderBottom: "2px solid #ddd",
  textAlign: "left",
  fontWeight: "bold",
  backgroundColor: "#f4f4f4",
};

const tableCellStyle = {
  padding: "8px",
  borderBottom: "1px solid #ddd",
};

const tableRowStyle = {
  borderBottom: "1px solid #ddd",
};

const deleteButtonStyle = {
  backgroundColor: "red",
  color: "white",
  border: "none",
  borderRadius: "4px",
  padding: "5px 10px",
  cursor: "pointer",
};
